import { memo, useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from '@/app/store/hooks';
import { balloonActions, BalloonStatus, selectBalloonStatus } from '@/entities/balloon';
import { type CurrencyCode, getGameCurrencyLimits } from '@/shared/lib/currency';
import { useJoinGame } from '@/shared/lib/hooks/useJoinGame';
import { useTelegramBackButton } from '@/shared/lib/telegram/useTelegramBackButton';

import { BalloonBetPanel } from './ui/BalloonBetPanel';
import { BalloonVisual } from './ui/BalloonVisual';

const RESULT_DISPLAY_MS = 1800;

export const BalloonPage = memo(() => {
  useTelegramBackButton();
  useJoinGame('balloon');
  const dispatch = useAppDispatch();
  const status = useAppSelector(selectBalloonStatus);

  const [betAmount, setBetAmount] = useState(0.5);
  const [selectedCurrency, setSelectedCurrency] = useState<CurrencyCode>('STARS');

  useEffect(() => {
    setBetAmount(getGameCurrencyLimits('balloon', selectedCurrency).minBet);
  }, [selectedCurrency]);

  useEffect(() => {
    if (status === BalloonStatus.WON || status === BalloonStatus.BUSTED) {
      const t = setTimeout(() => dispatch(balloonActions.resetGame()), RESULT_DISPLAY_MS);
      return () => clearTimeout(t);
    }
  }, [status, dispatch]);

  return (
    <div className="game-page" style={{ padding: '0.5rem 1rem 2.5rem' }}>
      <div className="game-page__canvas-wrap" style={{ height: 330, borderRadius: 'var(--radius-xl)', overflow: 'hidden', margin: '1rem 0' }}>
        <BalloonVisual />
      </div>
      <BalloonBetPanel
        betAmount={betAmount}
        setBetAmount={setBetAmount}
        selectedCurrency={selectedCurrency}
        setSelectedCurrency={setSelectedCurrency}
      />
    </div>
  );
});

export default BalloonPage;
